export default __webpack_public_path__ + "static/media/V860MAND1.e97b08ae.pdf";